
import * as React from 'react';
import { useForm } from "react-hook-form";
import DottedSpinner from "../../Core/DottedSpinner/DottedSpinner";
import useResetPassword from "./Hooks/useResetPassword";

import {Route, Link, Routes, useParams, useSearchParams} from 'react-router-dom';


export default function ResetPassword() {


  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");


  const form = useForm();
  const { register, handleSubmit, watch, formState } = form;
  const { errors } = formState;
  const formValues = watch();
  const { resetPassword, loading } = useResetPassword(formValues);

  return (
  <section component="form" onSubmit={handleSubmit(resetPassword)} class="bg-gray-50 dark:bg-gray-900">
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <a href="/" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          DigiForm
      </a>
      <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Reset Password
              </h1>
          
              <form class="space-y-4 md:space-y-6" action="#">

                  <input type="hidden" defaultValue={id} {...register("transactionId")} />

                  <div>
                      <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">New password</label>
                      <input 
                      {...register("password", { required: "Password is required" })}
                      type="password" name="password" id="password" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="********" required=""/>
                  </div>

                  <div>
                      <label for="confirmpassword" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm password</label>
                      <input 
                      {...register("confirmpassword", { required: "Password is required" })}
                      type="password" name="confirmpassword" id="confirmpassword" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="********" required=""/>
                  </div>

                  <button type="submit" class="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                  {loading ? <DottedSpinner /> : <span>Reset Password</span>}
                  </button>
              </form>
          </div>
      </div>
  </div>
</section>);
}